import { motion } from 'framer-motion'

const CATEGORIES = ['All', 'Decoration', 'Entertainment', 'Characters', 'Cakes']

/**
 * GalleryFilter — pill-style category filter bar.
 *
 * Props:
 *   active    — currently selected category string
 *   onChange  — callback(category: string)
 */
export default function GalleryFilter({ active = 'All', onChange }) {
  return (
    <div
      className="flex flex-wrap justify-center gap-2 mb-10"
      role="group"
      aria-label="Filter gallery by category"
    >
      {CATEGORIES.map((cat) => {
        const isActive = active === cat
        return (
          <motion.button
            key={cat}
            whileTap={{ scale: 0.95 }}
            onClick={() => onChange(cat)}
            className={[
              'px-5 py-2 rounded-full font-body font-semibold text-sm transition-all duration-250',
              isActive
                ? 'bg-primary text-white shadow-glow-primary'
                : 'bg-surface text-ink-muted border border-primary-100 hover:border-primary hover:text-primary',
            ].join(' ')}
            aria-pressed={isActive}
          >
            {cat}
          </motion.button>
        )
      })}
    </div>
  )
}
